import { connectorsForWallets } from '@rainbow-me/rainbowkit';
import {
  backpackWallet,
  metaMaskWallet,
  okxWallet,
  rabbyWallet,
  trustWallet,
  walletConnectWallet,
} from '@rainbow-me/rainbowkit/wallets';
import type { Chain } from 'viem';
import { mainnet, monad } from 'viem/chains';
import { createConfig, fallback, http } from 'wagmi';
// import { EmailWalletConnect } from './custom_email_button.tsx';
import { POLLING_TIMEOUT } from '@/common/timeout_constants.ts';
import { guardConnectorSetup } from '@/utils/connectorSetupGuard';
import { environment } from '../../environment.ts';
import { funkitCheckoutChains, funkitDefaultTransports } from '../../providers/fun_bridge/funkit_chains';
import { captureError } from '../../utils/sentryHelpers';

const connectors = connectorsForWallets(
  [
    {
      groupName: 'Recommended',
      wallets: [metaMaskWallet, rabbyWallet, okxWallet, backpackWallet, trustWallet, walletConnectWallet],
    },
  ],
  {
    appName: 'DEX App',
    projectId: environment.reownAppId,
    appUrl: location.origin,
  }
).map(guardConnectorSetup);

const rpcProxyUrl = import.meta.env.VITE_RPC_PROXY_TARGET ? '/rpc-proxy' : undefined;

const buildConfig = (monadNet: Chain, multiInjectedProviderDiscovery: boolean) =>
  createConfig({
    connectors,
    multiInjectedProviderDiscovery,
    pollingInterval: POLLING_TIMEOUT,
    chains: [monadNet, monad, ...funkitCheckoutChains],
    transports: {
      [monadNet.id]: rpcProxyUrl ? http(rpcProxyUrl) : http(),
      [monad.id]: http(),
      ...funkitDefaultTransports(),
      // Funkit's default mainnet transport is a single `http()` to eth.merkle.io with no fallback;
      // it intermittently returns `0x` for the Universal Resolver V2 reverseWithGateways call,
      // which crashes RainbowKit's automatic ENS lookup.
      [mainnet.id]: fallback([http('https://eth.drpc.org'), http('https://ethereum-rpc.publicnode.com'), http()]),
    },
  });

export const rainbowConfig = (monadNet: Chain) => {
  try {
    return buildConfig(monadNet, true);
  } catch (error) {
    // EIP-6963 discovery parses announcements from extensions we don't control, and this runs
    // during render — a throw kills the app. Boot with the declared wallets only.
    captureError(error, 'wagmi_provider_discovery');
    return buildConfig(monadNet, false);
  }
};
